"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/Persona/index'));

//# sourceMappingURL=Persona.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./Persona.js
 ** module id = 172
 ** module chunks = 0
 **/